import corp1 from './/Corp1.jpg';
import corp2 from './/Corp2.jpg';
import corp3 from './/Corp3.jpg';
import corp4 from './/Corp4.jpg';
import corp5 from './/Corp5.jpg';
import corp6 from './/Corp6.jpg';
import corp7 from './/Corp7.jpg';
import corp8 from './/Corp8.jpg';
import corp9 from './/Corp9.jpg';
import corp10 from './/Corp10.jpg';
import corp11 from './/Corp11.jpg';
import corp12 from './/Corp12.jpg';
import corp13 from './/Corp13.jpg';
import corp14 from './/Corp14.jpg';
import corp15 from './/Corp15.jpg';
import corp16 from './/Corp16.jpg';
import corp17 from './/Corp17.jpg';
import corp18 from './/Corp18.jpg';
import corp19 from './/Corp19.jpg';
import corp20 from './/Corp20.jpg';
import corp21 from './/Corp21.jpg';
import corp22 from './/Corp22.jpg';

export interface CustomImage {
  src: string;
  original: string;
  width: number;
  height: number;
}

export const images: CustomImage[] = [
  {
    src: corp1,
    original: corp1,
    width: 200,
    height: 200,
  },
  {
    src: corp2,
    original: corp2,
    width: 200,
    height: 212,
  },
  {
    src: corp3,
    original: corp3,
    width: 200,
    height: 212,
  },
  {
    src: corp4,
    original: corp4,
    width: 150,
    height: 213,
  },
  {
    src: corp5,
    original: corp5,
    width: 150,
    height: 183,
  },
  {
    src: corp6,
    original: corp6,
    width: 300,
    height: 320,
  },
  {
    src: corp7,
    original: corp7,
    width: 150,
    height: 200,
  },
  {
    src: corp8,
    original: corp8,
    width: 150,
    height: 148,
  },
  {
    src: corp9,
    original: corp9,
    width: 320,
    height: 213,
  },
  {
    src: corp10,
    original: corp10,
    width: 300,
    height: 320,
  },
  {
    src: corp11,
    original: corp11,
    width: 100,
    height: 113,
  },
  {
    src: corp12,
    original: corp12,
    width: 300,
    height: 320,
  },
  {
    src: corp13,
    original: corp13,
    width: 320,
    height: 213,
  },
  {
    src: corp14,
    original: corp14,
    width: 200,
    height: 194,
  },
  {
    src: corp15,
    original: corp15,
    width: 200,
    height: 213,
  },
  {
    src: corp16,
    original: corp16,
    width: 271,
    height: 320,
  },
  {
    src: corp17,
    original: corp17,
    width: 200,
    height: 320,
  },
  {
    src: corp18,
    original: corp18,
    width: 271,
    height: 320,
  },
  {
    src: corp19,
    original: corp19,
    width: 271,
    height: 320,
  },
  {
    src: corp20,
    original: corp20,
    width: 271,
    height: 320,
  },
  {
    src: corp21,
    original: corp21,
    width: 271,
    height: 320,
  },
  {
    src: corp22,
    original: corp22,
    width: 271,
    height: 320,
  },
  
  
];